import { style } from "@vanilla-extract/css";
import { calc } from "@vanilla-extract/css-utils";
import { breakpoints, vars } from "../../styles";
import { buttonStyles } from "../buttons/Button/Button.recipe";

export const fixturesContainer = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.xs,
});

export const fixturesHeader = style({
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
});

export const fixturesTitle = style({
  fontSize: vars.fontSizes.heading["2xl"],
});

export const addToCalendarButton = style([
  buttonStyles({
    size: "small",
    appearance: "tonal",
  }),
  {
    position: "absolute",
    top: 0,
    insetInlineEnd: 0,
  },
]);

export const fixturesPager = style({
  display: "flex",
  justifyContent: "space-between",
  margin: `${calc.negate(vars.space["3xl"])} 15% 0 15%`,
  padding: vars.space.xs,
  "@media": {
    [`(min-width: ${breakpoints[2]})`]: {
      margin: `${calc.negate(vars.space["3xl"])} 25% 0 25%`,
    },
  },
});

export const note = style({
  textAlign: "center",
  color: vars.colors.onSurfaceVariant,
  fontFamily: vars.fonts.bold,
  fontSize: vars.fontSizes.body.s,
});

export const eventContainer = style({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  textAlign: "center",
});

export const fixturesButton = style({
  display: "flex",
  color: vars.colors.onPrimaryContainer,
});

export const eventTitle = style({
  margin: 0,
  fontSize: vars.fontSizes.heading.m,
});

export const eventsDates = style({
  color: vars.colors.onSurfaceVariant,
  fontSize: vars.fontSizes.body.m,
});

export const fixturesList = style({
  padding: 0,
  listStyle: "none",
});

export const fixtureListItem = style({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  width: "100%",
  selectors: {
    "&:not(:last-child)::after": {
      position: "absolute",
      bottom: 0,
      left: "50%",
      transform: "translateX(-50%)",
      backgroundColor: vars.colors.outlineVariant,
      width: "50%",
      maxWidth: "17.2rem",
      height: "1px",
      content: '""',
    },
  },
  "@media": {
    [`(min-width: ${breakpoints[2]})`]: {
      selectors: {
        "&:not(:last-child)::after": {
          maxWidth: "67.3rem",
        },
      },
    },
  },
});
